import type { Editor } from "@tiptap/react";
import { NodeViewWrapper } from "@tiptap/react";
import { classNames } from "@/react/helpers/twMergeWithCN";
import { getCurrentRange } from "@circle-react-shared/uikit/TipTapBlockEditor/Toolbar/helpers";
import { useBlockEditorContext } from "@circle-react-uikit/TipTapBlockEditor";
import { CTAOptions } from "./CTAOptions";
import { useCTASettingsModal } from "./CTASettingsModal";

interface RendererProps {
  deleteNode: () => void;
  editor: Editor;
  node: any;
  selected: boolean;
  updateAttributes: any;
}

export const Renderer = ({
  editor,
  node,
  updateAttributes,
  deleteNode,
  selected,
}: RendererProps) => {
  const isEditable = editor.isEditable;
  const ctaSettingsModal = useCTASettingsModal();
  const { isWithinEmailEditor } = useBlockEditorContext() || {};

  const handleCtaClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    if (!isEditable) return;

    event.preventDefault();
    ctaSettingsModal
      .show({
        editor,
        range: getCurrentRange({ editor }),
        isWithinEmailEditor,
      })
      .catch(console.error);
  };

  return (
    <NodeViewWrapper
      as="div"
      className={classNames(
        "group relative my-2 flex items-center rounded-lg border py-4",
        {
          "justify-center": node.attrs.alignment === "center",
          "justify-start": node.attrs.alignment === "left",
          "justify-end": node.attrs.alignment === "right",
        },
        {
          "border-transparent": !isEditable,
          "hover:border-dark border-transparent": isEditable && !selected,
          "border-circle": isEditable && selected,
        },
      )}
    >
      <a
        style={{
          backgroundColor: node.attrs.color,
          color: node.attrs.text_color,
        }}
        className={classNames(
          "tiptap-cta focus-visible:!outline-secondary group relative block rounded-full px-6 py-2.5 font-bold transition-opacity hover:opacity-90 focus-visible:!outline focus-visible:!outline-2 focus-visible:!outline-offset-2",
          node.attrs.full_width ? "w-[350px] text-center" : "w-auto",
          !node.attrs.text_color && "!text-white",
        )}
        target="_blank"
        href={node.attrs.url}
        rel="noreferrer"
        onClick={handleCtaClick}
      >
        {node.attrs.label}
      </a>
      {isEditable && (
        <CTAOptions
          editor={editor}
          node={node}
          updateAttributes={updateAttributes}
          deleteNode={deleteNode}
        />
      )}
    </NodeViewWrapper>
  );
};
